export default __webpack_public_path__ + "static/media/SPEL Logo 1.6 ratio.c7b6aa4c.jpg";